import { memo } from 'react'

import { Text } from 'common-components'
import * as Styled from './styled'

interface IProps {
  value: number
  isSelected: boolean
  onClick: (value: number) => void
  setNode: (node: HTMLDivElement) => void
}

const PlaybackSpeedOption: React.FC<IProps> = ({
  value,
  isSelected,
  onClick,
  setNode
}) => {
  const handleOnClick = () => {
    requestAnimationFrame(() => {
      onClick(value)
    })
  }

  return (
    <Styled.PlaybackSpeedOptionCell
      $isSelected={isSelected}
      onClick={handleOnClick}
      ref={isSelected ? setNode : null}
    >
      <Text type="h4" color="secondarySemiDark" lineHeight="15px">
        {value}
      </Text>
    </Styled.PlaybackSpeedOptionCell>
  )
}

export default memo(PlaybackSpeedOption)
